import { render, staticRenderFns } from "./LoginEmail.vue?vue&type=template&id=22c54706"
import script from "./LoginEmail.vue?vue&type=script&lang=js"
export * from "./LoginEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports